import { SearchTypeEnum } from './../../../../components/search-person-input/search-person-input.component';
import { ResponseCustom } from './../../../../models/ResponseCustom';

import {
    Component,
    ChangeDetectorRef,
    AfterViewInit,
    ViewChild,
    ElementRef,
    Input,
    Output,
    EventEmitter,
} from '@angular/core';
import { ModalConfig } from 'src/app/models/modalConfig';
import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FileDevolutionService } from './file-devolution.service';
import { CustomDatepickerI18n } from 'src/app/components/datepickeri18n/customDatePIckerI18n';
import { ReturnModalDevoluiton } from 'src/app/models/ReturnModalDevolution';
import { SessionBusiness } from 'src/app/core/_config/sessionBusiness.service';

@Component({
    selector: 'file-devolution',
    templateUrl: './file-devolution.component.html',
    styleUrls: ['./file-devolution.component.scss'],
})
export class FileDevolutionComponent implements AfterViewInit {
    constructor(
        private cdRef: ChangeDetectorRef,
        private modalService: NgbModal,
        private notificationsService: NotificationsService,
        private spinner: NgxSpinnerService,
        private fileDevolutionService: FileDevolutionService,
        private customDatepickerI18n: CustomDatepickerI18n,
        private sessionBusiness: SessionBusiness,
    ) {}

    @ViewChild('devolution') content: ElementRef;
    @ViewChild('content7') contentPerson: ElementRef;
    @Input() showHide: ModalConfig;

    @Output() clearClose = new EventEmitter();
    @Output() resShowHide = new EventEmitter();
    legalEntityListDevolution: any[] = [];
    legalEntityListDevolutionSelected: any = null;

    model: NgbDateStruct;

    resultServices: ResponseCustom;

    servicesGroupList = [];

    returnModalDevolution: ReturnModalDevoluiton;

    selectedGroupService;

    searchPersonType: SearchTypeEnum = SearchTypeEnum.PersonDocument;

    ngAfterViewInit(): void {
        this.cdRef.detectChanges();
    }

    ngOnChanges(changes: any) {
        this.cdRef.detectChanges();

        if (changes.showHide.currentValue.status) {
            if (this.showHide.element.error !== 1) {
                this.open(this.content, this.showHide);
            } else {
                this.openModalPerson(this.contentPerson);
            }
        }
    }

    openModalPerson(content) {
        this.modalService.open(content, {
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
        });
    }

    personSelected(ev) {
        this.modalService.dismissAll(this.contentPerson);
        this.open(this.content, this.showHide, ev);
    }

    close() {
        this.returnModalDevolution = {
            receivingLineId: this.showHide.element.id,
            clear: true,
        };

        this.clearModal();

        this.clearClose.emit(this.returnModalDevolution);
    }

    open(content, showHide, PersonParam?) {
        if (PersonParam) {
            this.showHide.element.responsibleId = PersonParam.id;
            this.showHide.element.responsibleName = PersonParam.fullName;
        }

        let responsibleId = PersonParam?.id;
        if (!responsibleId) {
            responsibleId = this.showHide.element.responsibleId;
        }

        let creditDate = new Date(showHide.element.creditDate);

        this.spinner.show();

        this.fileDevolutionService
            .getLegalEntityDevolutionFromFile(responsibleId, this.sessionBusiness.EntityIdContext)
            .subscribe((result) => {
                this.legalEntityListDevolution = result?.data;

                if (this.legalEntityListDevolution.length == 1) {
                    this.legalEntityListDevolutionSelected = this.legalEntityListDevolution[0];
                }
            });

        this.fileDevolutionService.getServicesGroup().subscribe((resultServices) => {
            if (resultServices.typeResponse === 3) {
                this.servicesGroupList = resultServices.data;

                this.model = {
                    day: creditDate.getUTCDate(),
                    month: creditDate.getUTCMonth() + 1,
                    year: creditDate.getUTCFullYear(),
                };

                this.modalService.open(content, {
                    size: 'lg',
                    keyboard: false,
                    backdrop: 'static',
                });
                this.showHide.status = false;
                this.resShowHide.emit(this.showHide);

                this.spinner.hide();
            } else {
                this.spinner.hide();
                this.close();
            }
        });
    }

    selectLegalEntity(data: any) {
        this.legalEntityListDevolutionSelected = data;
    }

    confirm() {
        if (this.legalEntityListDevolutionSelected == null) {
            this.notificationsService.info('Selecione uma Entidade Legal para Devolução');
            return;
        }

        let dateString = this.customDatepickerI18n.getDayAriaLabel(this.model);

        let devolution = {
            dateDevolution: new Date(dateString),
            serveGroupSelected: undefined,
            serveGroupSelectedName: undefined,
            legalEntityId: this.legalEntityListDevolutionSelected.legalEntityId,
            ResponsibleId: this.showHide.element.responsibleId,
            ResponsibleName: this.showHide.element.responsibleName,
            agreementCode: this.showHide.informBatch.agreementCode,
        };

        if (this.selectedGroupService) {
            devolution.serveGroupSelected = this.selectedGroupService.serviceGroupId;
            devolution.serveGroupSelectedName = this.selectedGroupService.description;
        }

        this.returnModalDevolution = {
            receivingLineId: this.showHide.element.id,
            devolution: devolution,
            type: 2,
        };

        this.clearClose.emit(this.returnModalDevolution);

        this.clearModal();
    }

    clearModal() {
        this.modalService.dismissAll();
        this.selectedGroupService = '';
    }
}
